import React from "react";
import TableRow from "./TableRow";

const TableBody = ({
  data,
  headers,
  rowKey,
  dropdownIndex,
  toggleDropdown,
  onActionClick,
  rowClassName,
}) => {
  if (data.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan={headers.length + 1} className="text-center py-4">
            No data available
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {data.map((row, idx) => (
        <TableRow
          key={row[rowKey]}
          row={row}
          headers={headers}
          rowKey={rowKey}
          isDropdownOpen={dropdownIndex === idx}
          toggleDropdown={toggleDropdown}
          onActionClick={onActionClick}
          rowIndex={idx}
          rowClassName={rowClassName}
        />
      ))}
    </tbody>
  );
};

export default TableBody;
